module.exports = __webpack_public_path__ + "tables/media/stocksDown.0fb6db63.svg";